import Base from '../base';
import BlogTitlesParser from './blog-titles-parser';
import {
  TABLE_OF_CONTENTS_TAG_NAME,
  TABLE_OF_CONTENTS_TITLE_REFERENCE,
  TABLE_OF_CONTENTS_SUBTITLE_REFERENCE,
  TABLE_OF_CONTENTS_REFERENCE_CONTAINER,
  TABLE_OF_CONTENTS_REFERENCE_TEXT_CONTAINER,
  TABLE_OF_CONTENTS_SUBTITLE_TAG,
  TABLE_OF_CONTENTS_SAMPLE,
  TABLE_OF_CONTENTS_REFERENCE_SAMPLE
} from '../../../classnames/blog';
import { HIDDEN } from '../../../classnames/design-system';

export default class TableOfContents extends Base {
  tagName = TABLE_OF_CONTENTS_TAG_NAME;
  blogTitlesParser = new BlogTitlesParser();
  sample = document.querySelector(`.${TABLE_OF_CONTENTS_SAMPLE}`);
  referenceSample = document.querySelector(`.${TABLE_OF_CONTENTS_REFERENCE_SAMPLE}`);

  addIdToTitle = ({ node, id }) => {
    node.setAttribute('id', id);
  };

  buildReference = ({ node, id }) => {
    const reference = this.referenceSample.cloneNode(true);
    let className = TABLE_OF_CONTENTS_TITLE_REFERENCE;
    if (node.tagName === TABLE_OF_CONTENTS_SUBTITLE_TAG) {
      className = TABLE_OF_CONTENTS_SUBTITLE_REFERENCE;
    }
    reference.classList.add(className);
    reference.classList.remove(TABLE_OF_CONTENTS_REFERENCE_SAMPLE);
    reference.setAttribute('href', `#${id}`);
    const textContainer = reference.querySelector(TABLE_OF_CONTENTS_REFERENCE_TEXT_CONTAINER);
    textContainer.innerText = node.innerText;
    return reference;
  };

  buildNode = (_placeholder) => {
    const newNode = this.sample.cloneNode(true);
    const referenceContainer = newNode.querySelector(`.${TABLE_OF_CONTENTS_REFERENCE_CONTAINER}`);
    newNode.classList.remove(TABLE_OF_CONTENTS_SAMPLE, HIDDEN);
    const nodesWithIds = this.blogTitlesParser.getNodesWithIds();

    nodesWithIds.forEach(({ node, id }) => {
      if (id.length > 0) {
        this.addIdToTitle({ node, id });
        referenceContainer.appendChild(this.buildReference({ node, id }));
      }
    });

    return newNode;
  };
}
